// jquery
import $ from 'jquery';
window.$ = window.jQuery = $;
// swiper
import Swiper from 'swiper';
window.Swiper = Swiper;
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper';
window.SwiperModules = {
    Navigation: Navigation,
    Pagination: Pagination,
    Thumbs: Thumbs,
    Autoplay: Autoplay,
}
// imask
import IMask from 'imask';
window.IMask = IMask;
// lightGallery
import lightGallery from 'lightgallery';
import zoom from 'lightgallery/plugins/zoom';
import thumbnail from 'lightgallery/plugins/thumbnail';
window.lightGallery = lightGallery;
window.lgModules = {
    zoom: zoom,
    thumbnail: thumbnail

};

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});